import {BaseContainerModel} from '../../base-container.model';
import { bl_inv_bin_gen_doc_link } from '../../../dbschema';

export class BinGenDocLinkModel extends BaseContainerModel {
  bl_inv_bin_gen_doc_link: bl_inv_bin_gen_doc_link
}
